/**
 * Shared constants for Route Optimizer components.
 * Single source of truth for colors, tiers, and budget options.
 */

export const ROUTE_COLORS = [
  '#e6194b', '#3cb44b', '#ffe119', '#4363d8', '#f58231', '#911eb4',
  '#42d4f4', '#f032e6', '#bfef45', '#fabed4', '#469990', '#dcbeff',
  '#9A6324', '#fffac8', '#800000', '#aaffc3', '#808000', '#ffd8b1',
  '#000075', '#a9a9a9', '#e6beff', '#1abc9c', '#ff6347', '#00ced1',
];

export const TIER_ORDER = ['quick', 'standard'];

export const BUDGET_OPTIONS = [
  { value: 'quick', tier: 'quick', label: 'Quick Optimization' },
  { value: 'standard', tier: 'standard', label: 'Standard Optimization' },
];

export const TIER_LABELS = { quick: 'Quick', standard: 'Standard' };
